// @file Vuex plugin that allow electron APIs process the Vuex state
import fetchElectronBridge from 'bits/electron_bridge'
import { Store } from 'vuex'

// Filter events to prevent every mutation can trigger the electron API call
const isElectronProcessable = (mutationType: string): boolean => {
  const processableTypes = ['electronApp/SET_CURRENT_USER', 'electronApp/LOG_OUT']
  return processableTypes.includes(mutationType)
}

/**
 * Proposal:
 *  - Let the electron app process the Vuex state
 *  - The electron app will make decisions based on the Vuex state
 *  - Keep the electron bridge's API very simple
 */
export default <T>(moduleName: string) => (store: Store<T>): void => {
  store.subscribe((mutation, state) => {
    if (isElectronProcessable(mutation.type)) {
      const electronApp = fetchElectronBridge()
      electronApp.webAppStateHasChanged?.(moduleName, state)
    }
  })
}
